export default __webpack_public_path__ + "static/media/white-logo-lg.af37a889.png";